import Stats from '../helpers/Stats';
import General from '../helpers/General';
import bindSwipeGesture from '../helpers/SwipeGesture';
import { mobile } from '../constants';
import initCollectionGenderSwitcher from './CollectionGenderSwitcher';

export default class CollectionFilters {
  constructor() {
    this.clickToogleFilterButton();
    this.toogleCollapseFilters();
    this.clickClearFitlersButton();
    // this.toogleFilter();
    window.toogleFilters = this.toggleFilters.bind(this);
    window.toggleFilters = this.toggleFilters.bind(this);
    window.toogleCollapseFilters = this.toogleCollapseFilters.bind(this);
    // this.filterBestLink();
    initCollectionGenderSwitcher();

    if (mobile) {
      this.closeFiltersOnMobile();
    }
  }

  clickToogleFilterButton(e) {
    const $_button = document.querySelector(
      '[data-filter-action="toggle-drawer"]'
    );
    if ($_button) {
      $_button.addEventListener('click', this.toggleFilters, false);

      $_button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.toggleFilters();
        }
      });
    }
  }

  clickClearFitlersButton() {
    const area = document.querySelector('[data-filter-drawer]'); // the container for the variable content
    if (area) {
      const selector = '[data-filter-action="clear"]'; // any css selector for children
      const execEvent = (event) => {
        let item = event.target.closest(selector);

        if (item) {
          event.preventDefault();
          item.classList.add('twc-btn--loading');
          const eventData = {
            event_category: 'filters--new',
            event_label: 'footerbtn_apply',
          };
          Stats.sendEventDataLayerViaShopify(eventData);
          window.location.href = window.location.pathname;
        }
      };

      area.addEventListener('click', function (event) {
        execEvent(event);
      });
    }
  }

  toggleFilters() {
    const $_button = document.querySelector(
      '[data-filter-action="toggle-drawer"]'
    );
    const $_filters = document.querySelector('[data-filter-content]');
    if ($_button && $_filters) {
      const isOpen = $_filters.dataset.filterDrawerState !== 'open';

      $_filters.dataset.filterDrawerState = isOpen ? 'open' : 'closed';
      const new_text = isOpen
        ? $_button.dataset.filterLabelShow || 'Show filters'
        : $_button.dataset.filterLabelHide || 'Hide filters';
      $_button.querySelector('[data-filter-label]').innerText = new_text;

      if (mobile) {
        General.bodyOverflowHiddenController(
          'collection-filters',
          $_filters.dataset.filterDrawerState === 'open',
          false
        );
      }

      if (isOpen) {
        const event_category = 'filters--new';

        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: 'filters-mobile-opened',
        });
      }
    }
  }

  toogleCollapseFilters() {
    const area = document.querySelector('[data-filter-drawer]'); // the container for the variable content
    if (area) {
      const selector = '[data-filter-action="toggle-group"]'; // any css selector for children
      const execEvent = (event) => {
        let item = event.target.closest(selector);

        if (item) {
          const filter_wrapper = item.closest('[data-filter-group]');
          const filter_name = filter_wrapper.dataset.filterName || '';

          if (filter_wrapper) {
            const isExpanded =
              filter_wrapper.dataset.filterGroupState === 'collapsed';
            filter_wrapper.dataset.filterGroupState = isExpanded
              ? 'open'
              : 'collapsed';
            item.setAttribute('aria-expanded', isExpanded);

            const event_category = 'filters--new';
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `toggle_${filter_name.replace(/ /g, '')}`,
            });
          }
        }
      };

      area.addEventListener('click', function (event) {
        execEvent(event);
      });
    }
  }

  closeFiltersOnMobile() {
    const area = document.querySelector('[data-filter-drawer]'); // the container for the variable content
    if (area) {
      const selector = '[data-filter-action="close-drawer"]';
      const selector2 = '[data-filter-action="apply-drawer"]';
      const filters = document.querySelector('[data-filter-content]');
      const execEvent = (event) => {
        let item =
          event.target.closest(selector) || event.target.closest(selector2);
        const event_category = 'filters--new';

        if (item?.matches(selector)) {
          Stats.sendEventDataLayerViaShopify({
            event_category: event_category,
            event_label: 'close_filters_mobile',
          });
        } else if (item?.matches(selector2)) {
          Stats.sendEventDataLayerViaShopify({
            event_category: event_category,
            event_label: 'footerbtn_apply',
          });
        } else if (!item && event.target === area) {
          item = event.target;
        }
        if (item) {
          this.toggleFilters();
        }
      };
      area.addEventListener('click', function (event) {
        // event.preventDefault();
        execEvent(event);
      });

      bindSwipeGesture(area, {
        direction: 'right',
        moveElement: area.querySelector('[data-filter-facet-form]'),
        shouldSwipe: () => filters?.dataset.filterDrawerState === 'open',
        onSwipe: () => {
          Stats.sendEventDataLayerViaShopify({
            event_category: 'filters--new',
            event_label: 'close_filters_mobile_swipe',
          });
          this.toggleFilters();
        },
      });
    }
  }
}
